<template>
  <vs-popup title="Bulk Change Password" :active.sync="localData">
    <div class="flex flex-col overflow-hidden">
      <p style="width: 600px">Ubah kata sandi secara massal</p>
      <div class="mt-5 flex flex-col" style="gap: 15px">
        <div>
          <label for="">Tipe</label>
          <vs-select v-model="selectedType" class="w-full">
            <vs-select-item
              v-for="type in types"
              :key="type.value"
              :value="type.value"
              :text="type.label" />
          </vs-select>
        </div>
        <div v-if="selectedType == 'manual'">
          <div>
            <label for="">Password Baru</label>
            <div style="position: relative">
              <vs-input
                data-vv-validate-on="blur"
                v-validate="'required|min:1|max:15'"
                :type="show_pwd ? 'text' : 'password'"
                name="password"
                icon="icon icon-lock"
                icon-pack="feather"
                v-model="password"
                class="w-full no-icon-border" />
              <div
                @click="show_pwd = !show_pwd"
                style="
                  position: absolute;
                  right: 10px;
                  top: 9px;
                  cursor: pointer;
                ">
                <feather-icon
                  icon="EyeIcon"
                  v-if="show_pwd"
                  svgClasses="h-4 w-4" />
                <feather-icon
                  icon="EyeOffIcon"
                  v-if="!show_pwd"
                  svgClasses="h-4 w-4" />
              </div>
            </div>
          </div>
          <div>
            <label for="">Konfirmasi Password Baru</label>
            <div style="position: relative">
              <vs-input
                data-vv-validate-on="blur"
                v-validate="'required|min:1|max:15'"
                :type="show_pwd_confirm ? 'text' : 'password'"
                name="password_confirm"
                icon="icon icon-lock"
                icon-pack="feather"
                v-model="password_confirm"
                class="w-full no-icon-border" />
              <div
                @click="show_pwd_confirm = !show_pwd_confirm"
                style="
                  position: absolute;
                  right: 10px;
                  top: 9px;
                  cursor: pointer;
                ">
                <feather-icon
                  icon="EyeIcon"
                  v-if="show_pwd_confirm"
                  svgClasses="h-4 w-4" />
                <feather-icon
                  icon="EyeOffIcon"
                  v-if="!show_pwd_confirm"
                  svgClasses="h-4 w-4" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 flex flex-row w-full" style="gap: 10px">
        <vs-button
          color="danger"
          class="w-full font-bold"
          @click="openConfirmation"
          :disabled="
            selectedType == 'manual' &&
            password == '' &&
            password != password_confirm
          "
          >Submit</vs-button
        >
      </div>
      <vs-popup title="" :active.sync="confirmation">
        <div class="flex flex-col">
          <svg
            class="mb-5"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFD4D4" />
            <path
              d="M25 21.25V26.25M25 31.25H25.0125M22.8625 14.825L12.275 32.5C12.0567 32.878 11.9412 33.3066 11.94 33.7432C11.9387 34.1797 12.0518 34.6089 12.268 34.9882C12.4842 35.3674 12.7959 35.6834 13.1721 35.9048C13.5483 36.1262 13.976 36.2452 14.4125 36.25H35.5875C36.024 36.2452 36.4516 36.1262 36.8278 35.9048C37.2041 35.6834 37.5158 35.3674 37.7319 34.9882C37.9481 34.6089 38.0612 34.1797 38.06 33.7432C38.0588 33.3066 37.9433 32.878 37.725 32.5L27.1375 14.825C26.9146 14.4576 26.6009 14.1539 26.2265 13.9431C25.8521 13.7323 25.4296 13.6216 25 13.6216C24.5703 13.6216 24.1479 13.7323 23.7735 13.9431C23.3991 14.1539 23.0853 14.4576 22.8625 14.825Z"
              stroke="#FF3939"
              stroke-opacity="0.8"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          <h4 class="mb-3 font-bold">
            Apakah Anda yakin untuk menganti kata sandi secara masal?
          </h4>
          <p v-if="selectedType == 'auto'">
            Kata sandi semua akun akan terganti pada
            <b> tanggal 1 pada bulan berikutnya. </b>
            Kata sandi akan terganti dengan 8-16 karakter secara acak setiap
            user dan password akan dikirim ke email pengguna.
            <b> Pastikan user anda memiliki email yang aktif </b>
          </p>
          <p v-else>
            Kata sandi semua akun akan terganti pada
            <b> tanggal 1 pada bulan berikutnya. </b>
            Kata sandi akan terganti dengan kata sandi yang sudah diinput
            sebelumnya untuk semua user.
          </p>
        </div>
        <div class="mt-5 flex flex-row w-full" style="gap: 10px">
          <vs-button
            class="w-full font-bold"
            color="dark"
            type="border"
            @click="openConfirmation"
            >Batalkan</vs-button
          >
          <vs-button
            color="danger"
            class="w-full font-bold"
            @click="handleSubmit"
            :disabled="countdownConfirm > 0"
            >Update
            <span v-if="countdownConfirm > 0"
              >({{ countdownConfirm }})</span
            ></vs-button
          >
        </div>
      </vs-popup>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'
import * as moment from 'moment'

export default {
  props: {
    openModal: Boolean,
    // data: Object,
  },
  data() {
    return {
      baseMap: 'openstreetmap',
      otpInput: '',
      types: [
        {
          label:
            'Random (8-16 karakter secara acak dengan huruf besar dan kecil dan bebeda setiap user)',
          value: 'auto',
        },
        {
          label: 'Manual Input (Input password secara manual untuk semua user)',
          value: 'manual',
        },
      ],
      confirmation: false,
      countdownConfirm: 5,
      selectedType: 'auto',
      show_pwd: false,
      password: '',
      show_pwd_confirm: false,
      password_confirm: '',
    }
  },
  computed: {
    localData: {
      get() {
        return this.openModal
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
  },
  // for testing pupose
  // watch: {
  //   selectedDuration(val) {
  //
  //   },
  // },
  methods: {
    close() {
      this.$emit('closeModal', false)
    },
    openConfirmation() {
      this.confirmation = !this.confirmation

      if (this.confirmation) {
        this.countdownConfirm = 5
        const interval = setInterval(() => {
          this.countdownConfirm--
          if (this.countdownConfirm === 0) {
            clearInterval(interval)
          }
        }, 1000)
      } else {
        this.countdownConfirm = 5
      }
    },
    handleSubmit() {
      const body = {
        type: this.selectedType,
        password: this.password,
      }

      REPO.updatePassBulk(body)
        .then((res) => {
          this.$vs.notify({
            title:
              'Berhasil! Kata sandi akan diubah pada tanggal 1 pada bulan berikutnya',
            text: '',
            color: 'success',
          })
          this.$emit('closeModal', false)
        })
        .catch((err) => {
          this.$vs.notify({
            title: 'Gagal mengubah kata sandi! Silahkan coba lagi',
            text: '',
            color: 'danger',
          })
        })
    },
  },
}
</script>

<style lang="css">
.vs-popup {
  /* width: 450px !important; */
}
.otp-input {
  width: 80px;
  height: 80px;
  padding: 5px;
  /* margin: 0 10px; */
  font-size: 40px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
